import { render, staticRenderFns } from "./Commondevice.vue?vue&type=template&id=ff13d456"
import script from "./Commondevice.vue?vue&type=script&lang=js"
export * from "./Commondevice.vue?vue&type=script&lang=js"
import style0 from "./Commondevice.vue?vue&type=style&index=0&id=ff13d456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports